module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('toobarhead', {
    attrs: {
      "showRefresh": _vm.showRefresh,
      "showMore": _vm.showMore,
      "showBack": false,
      "titleName": _vm.titleName
    },
    on: {
      "refreshList": _vm.refresh,
      "showmoremenu": _vm.showmoremenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fixed-rb",
    attrs: {
      "id": "gotop"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.gotop.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "gotop"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page__bd",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "weui-tab"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavbar),
      expression: "showNavbar"
    }],
    staticClass: "weui-navbar"
  }, _vm._l((_vm.mainmenus), function(menu, index) {
    return _c('div', {
      staticClass: "weui-navbar__item",
      class: {
        'weui-bar__item_on': _vm.selected === index
      },
      on: {
        "click": function($event) {
          return _vm.requestInfo(index, menu.viewtype, true, false, "合同信息", false)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.text) + "\n              ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "weui-tab__panel"
  }, [_c('contractlist', {
    attrs: {
      "listInfo": _vm.getInfo,
      "viewType": _vm.viewtype
    }
  })], 1), _vm._v(" "), (_vm.btn_requestMore && _vm.list && _vm.list.length != 0) ? _c('div', {
    staticClass: "more"
  }, [_c('button', {
    staticClass: "weui-btn weui-btn_plain-default",
    on: {
      "click": function($event) {
        return _vm.requestMore()
      }
    }
  }, [_vm._v("加载更多")])]) : _vm._e(), _vm._v(" "), (_vm.list.length == 0 && !_vm.showLoading) ? _c('div', {
    staticClass: "weui-loadmore weui-loadmore_line"
  }, [_c('span', {
    staticClass: "weui-loadmore__tips"
  }, [_vm._v("暂无数据")])]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "weui-mask",
    attrs: {
      "id": "iosMask"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hidenMask.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    attrs: {
      "id": "actionsheet"
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNavbar),
      expression: "!showNavbar"
    }],
    staticClass: "weui-actionsheet__cell",
    on: {
      "click": function($event) {
        return _vm.requestInfo(0, 'audit', true, false, '合同信息', false)
      }
    }
  }, [_vm._v("合同信息")]), _vm._v(" "), _vm._l((_vm.secondmenus), function(secondm, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.titleName != secondm.text),
        expression: "titleName != secondm.text"
      }],
      staticClass: "weui-actionsheet__cell",
      on: {
        "click": function($event) {
          _vm.requestInfo(-(index + 2), secondm.viewtype, false, true, secondm.text, false)
        }
      }
    }, [_vm._v(_vm._s(secondm.text))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet__action"
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell",
    on: {
      "click": _vm.loginout
    }
  }, [_vm._v("退出登录(" + _vm._s(_vm.userName) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet__cell",
    on: {
      "click": _vm.hidenMask
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticClass: "list_loadingToast"
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "js_dialog loginoutDlg",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("确定退出吗")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stayin.apply(null, arguments)
      }
    }
  }, [_vm._v("放弃")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goout.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("加载中...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("退出登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc3a78ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 147
// module chunks = 2